import React from "react";
import { pipe } from "fp-ts/function";
import * as O from "fp-ts/Option";
import { getStringId, UUID } from "../../../../../../../lib/at-data/UUID";
import { OptionalTextCell } from "views/authenticated/assets/page/components/AssetsTable/cells/OptionalTextCell";

export const AssetLegacyIdCell: React.FC<{ value: O.Option<UUID> }> = ({
  value,
}) => pipe(value, O.map(getStringId), (v) => <OptionalTextCell value={v} />);
